<template>
  <v-card color="purple">
    <v-list-item>
      <v-list-item-avatar><v-icon>mdi-account</v-icon></v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{name}}</v-list-item-title>
        <v-list-item-subtitle><b>Age</b>: {{age}}, <b>Phone</b>: {{phone}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>

export default {
  name: 'Person',
  components: {},
  props : {
    name : {type:String,default:""},
    age : {type:Number,default:""},
    phone : {type:String,default:""},
  },
  computed : {},
}
</script>

<style scoped lang="scss">
</style>
